import { useGetChildrenGrades } from '@repo/api/parent/useGetChildrenGrades';
import { useGetMyChildren } from '@repo/api/parent/useGetMyChildren';

import GradeCard from '@/components/features/grades/GradeCard';
import { ChildSectionList } from '@/components/features/parent/ChildSectionList';
import ParentPageHeader from '@/components/features/parent/layout/ParentPageHeader';
import { ParentListSection } from '@/components/features/parent/ParentListSection';
import { ParentListToolbar } from '@/components/features/parent/ParentListToolbar';
import { useParentListParams } from '@/hooks/parent';

export default function ParentGradesPage() {
  const { data: children = [], isPending: isPendingChildren, isError, errorMessage } = useGetMyChildren();
  const listParams = useParentListParams();

  const { results, failed, isPending } = useGetChildrenGrades(children, listParams.buildParamsFor, !isPendingChildren);

  return (
    <div className={'base-direction-col'}>
      <div className={'flex w-full grow flex-col gap-6'}>
        <ParentPageHeader title={'Oceny'}>
          <ParentListToolbar childUsers={children} listParams={listParams} />
        </ParentPageHeader>

        <ChildSectionList
          results={results}
          failed={failed}
          isPending={isPendingChildren || isPending}
          isError={isError}
          errorMessage={errorMessage}
          summary={(data) => `Wyników: ${data.total}`}
          defaultExpanded={'none'}
        >
          {(data, child) => (
            <ParentListSection childId={child.id} data={data} listParams={listParams} emptyMessage={'Brak ocen'}>
              {(grades) => (
                <div
                  className={'border-border-primary bg-background [&>*:nth-child(odd)]:bg-card/25 [&>*:not(:last-child)]:border-border-primary/75 rounded-2xl border [&>*:not(:last-child)]:border-b'}
                >
                  {grades.map((grade) => (
                    <GradeCard key={grade.id} grade={grade} className={'px-4'} />
                  ))}
                </div>
              )}
            </ParentListSection>
          )}
        </ChildSectionList>
      </div>
    </div>
  );
}
